import {get} from '@/utils/request'
const comApi = {
  /* 发送邮箱验证码 */
  sendCode: function (params) {
    return get('merchant/SendMailVerificationCode.do', {
      type: params.type, /* 验证码类型（register=注册,backPasswd=找回密码） */
      mail: params.mail
    })
  },
  /* 获取商户信息 */
  getMerchant: function () {
    return get('merchant/getMerchant.do', {
    })
  }
}
export default comApi



// WEBPACK FOOTER //
// ./src/api/comApi.js